module.exports = __webpack_public_path__ + "img/sztb.9dd4bd26.png";